import styled from "styled-components";

import glass from "../../../assets/images/icons/glass-transparent.png";
import grapes from "../../../assets/images/icons/grapes-yellow.png";
import globe from "../../../assets/images/icons/globe-transparent.png";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const TasteSummaryWrapper = styled.div<{ isWineDetailsPage: boolean }>`
  padding: 32px 15px;
  ${(props) => props.isWineDetailsPage && "padding: 40px 70px"};

  ${breakpoints.smDown} {
    ${(props) => props.isWineDetailsPage && "padding: 20px 15px"};
  }
`;

export const TasteSummaryTitle = styled.div`
  font-family: ${fonts.fontBauMedium};
  text-transform: uppercase;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 24px;

  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

export const InfoSection = styled.div`
  background: ${colors.warningTransparent};
  display: flex;
  padding: 16px 25px;
  margin-bottom: 1px;
  font-family: ${fonts.fontBauRegular};
  font-size: 18px;
  line-height: 25px;

  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const InfoTextWrapper = styled.div`
  display: inline;
`;

export const WineCharacteristicsInfoSection = styled(InfoSection)`
  border-radius: 5px 5px 0px 0px;

  ${breakpoints.smDown} {
    border-radius: 5px;
  }
`;

export const GrapeInfoSection = styled(InfoSection)``;

export const RegionInfoSection = styled(InfoSection)`
  border-radius: 0px 0px 5px 5px;
`;

const Icon = styled.img`
  height: 32px;
  width: 32px;
  margin-right: 30px;
`;

export const GlassIcon = styled(Icon).attrs(() => ({ src: glass }))<{
  isWineDetailsPage: boolean;
}>`
  display: flex;
  ${(props) => !props.isWineDetailsPage && "margin-top: 24px"};
  ${(props) => props.isWineDetailsPage && "align-self: center"};
`;

export const GrapesIcon = styled(Icon).attrs(() => ({ src: grapes }))`
  display: flex;
  align-self: center;
`;

export const GlobeIcon = styled(Icon).attrs(() => ({ src: globe }))`
  display: flex;
  align-self: center;
`;
